import defaultHeaders from '../../configuration/defaultHeaders';
import getApiUrl from '../../configuration/getApiUrl';
import getFetchCredentials from '../../configuration/getFetchCredentials';
import { isSupabaseAuthConfigured, signOutFromSupabase } from '../../lib/supabaseAuth';

const logOut = async () => {
  if (isSupabaseAuthConfigured()) {
    await signOutFromSupabase();
    return { status: 204 };
  }

  return fetch(`${getApiUrl()}/api/user/logout/`, {
    method: 'POST',
    headers: defaultHeaders,
    credentials: getFetchCredentials(),
  });
};

export default logOut;
